export default __webpack_public_path__ + "static/media/VL-MC3000BX-3.7d6380d0.jpg";